import { auth } from '../firebaseConfig';

export async function authFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not authenticated");
  }
  const token = await user.getIdToken();
  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
  if (res.status === 401) {
    // Esim. token vanhentunut / käyttäjä poistettu
    // auth.signOut(); // valinnainen
  }
  return res;
}